import PreMatriculasIndexPage from "@/Pages/PreMatriculas/PreMatriculasIndexPage.vue";
import PreMatriculaFormPage from "@/Pages/PreMatriculas/PreMatriculaFormPage.vue";
import AberturaPreMatriculasPage from "@/Pages/PreMatriculas/AberturaPreMatriculasPage.vue";

export default [
  {
    path: "/matriculas/prematriculas",
    name: "prematriculas",
    component: PreMatriculasIndexPage,
  },
  {
    path: "/matriculas/prematriculas/create",
    name: "prematriculas.create",
    component: PreMatriculaFormPage,
  },
  {
    path: "/matriculas/prematriculas/abertura",
    name: "prematriculas.abertura",
    component: AberturaPreMatriculasPage,
  },
];
